import * as React from 'react';
import { PaginationContext, PaginationContextProps, PaginationContextType } from './PaginationContext';
import { PaginationKeyInterface } from './PaginationKeyInterface';

export class PaginationContextProvider<T extends PaginationKeyInterface> extends React.Component<PaginationContextProps<T>> {
    public render() {
        const props = this.props;

        const paginationContext = new PaginationContext(
            props.itemsOnPage,
            props.pager,
            props.onSelectPage,
            props.initialPage,
            props.labels,
            props.maxPages,
            props.pageSize
        );

        return <PaginationContextType.Provider value={paginationContext}>{props.children}</PaginationContextType.Provider>;
    }
}
